import './index.css';
import iconOne from '../common-icons/footer-icon-one.png';
import iconTwo from '../common-icons/footer-icon-two.png';
import iconThree from '../common-icons/footer-icon-three.png';
import tmIcon from '../common-icons/tm-icon.png';

interface FooterProps {
  page?: string;
}
export default (props: FooterProps) => {
  return (
    <>
      <footer className="new-footer">
        <div className="footer-main">
          <div className="container">
            <div className="col-md-4">
              <div className="footer-logo-box">
                <a
                  className="footer-logo"
                  href="https://payrofinance.com/"
                >
                  <img
                    src="/logo-white.svg"
                    className="attachment-header_logo size-header_logo"
                    alt=""
                    decoding="async"
                    loading="lazy"
                  />{' '}
                </a>
              </div>
              <div className="footerSrt-dtl">
                <p>
                  The only funding product uniquely designed for
                  payoll
                </p>
              </div>
              <div className="social-icon">
                <ul className="social-links">
                  <li>
                    <a
                      href="https://www.facebook.com/payrofinance/"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        {/* <!-- <mask id="mask0_395_651" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                                          <path d="M20 0H0V20H20V0Z" fill="white"/>
                                      </mask> --> */}
                        <g mask="url(#mask0_395_651)">
                          <path
                            d="M7.85125 20.0001H11.5237V11.0551H14.3754L14.8438 7.50011H11.5237V5.04178C11.4805 4.60153 11.591 4.1599 11.8362 3.79178C12.0275 3.61166 12.2562 3.47616 12.5061 3.39503C12.756 3.31391 13.0207 3.28918 13.2812 3.32261H15.1562V0.156777C14.2485 0.0539789 13.3357 0.00167619 12.4221 0.000110269C11.8127 -0.0286905 11.2039 0.0673309 10.633 0.282282C10.0621 0.497233 9.54113 0.826579 9.10208 1.25011C8.66399 1.70316 8.32626 2.24342 8.11088 2.8357C7.89551 3.42797 7.80733 4.05898 7.85208 4.68761V7.50011H4.84375V11.0551H7.85125V20.0001Z"
                            fill="white"
                          ></path>
                        </g>
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/company/payrofinance/"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        {/* <!-- <mask id="mask0_395_659" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                                          <path d="M20 0H0V20H20V0Z" fill="white"/>
                                      </mask> --> */}
                        <g mask="url(#mask0_395_659)">
                          <path
                            d="M5.3949 18.3196V7.21461H1.94073V18.3196H5.3949ZM3.68656 5.69211C3.94974 5.694 4.21054 5.64229 4.45309 5.54014C4.69564 5.43799 4.91486 5.28754 5.0974 5.09795C5.28593 4.91443 5.43568 4.69491 5.53775 4.45241C5.63981 4.20991 5.69212 3.94938 5.69156 3.68628C5.67816 3.15798 5.46598 2.65417 5.0974 2.27545C4.71868 1.90686 4.21487 1.69468 3.68656 1.68128C3.42346 1.68072 3.16293 1.73303 2.92043 1.8351C2.67793 1.93716 2.45841 2.08691 2.2749 2.27545C2.0852 2.45808 1.93469 2.67743 1.83254 2.92013C1.73038 3.16283 1.67873 3.4238 1.68073 3.68711C1.67181 3.95126 1.72031 4.2142 1.82289 4.45777C1.92547 4.70135 2.07969 4.91977 2.2749 5.09795C2.45317 5.29326 2.67172 5.44754 2.91545 5.55013C3.15918 5.65271 3.42228 5.70116 3.68656 5.69211ZM18.3191 18.3196V12.2288C18.3996 10.9233 18.144 9.61895 17.5766 8.44045C17.1931 7.91585 16.6801 7.49977 16.0876 7.2329C15.4951 6.96603 14.8435 6.85751 14.1966 6.91795C13.4592 6.90971 12.7353 7.11615 12.1132 7.51211C11.6047 7.79241 11.1925 8.21964 10.9307 8.73795H10.8932V7.21461H7.58573V18.3196H11.0024V12.8196C10.9587 12.1427 11.0866 11.4657 11.3741 10.8513C11.532 10.5529 11.7755 10.3085 12.0734 10.1496C12.3713 9.99073 12.7099 9.92456 13.0457 9.95961C13.3836 9.93503 13.7205 10.0187 14.0076 10.1985C14.2947 10.3783 14.517 10.6449 14.6424 10.9596C14.8203 11.5873 14.8954 12.2396 14.8649 12.8913V18.3138L18.3191 18.3196Z"
                            fill="white"
                          ></path>
                        </g>
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        {/* <!-- <mask id="mask0_395_667" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                                          <path d="M20 0H0V20H20V0Z" fill="white"/>
                                      </mask> --> */}
                        <g mask="url(#mask0_395_667)">
                          <path
                            d="M10.2077 5.82329C10.9725 5.8366 11.721 6.04668 12.381 6.43329C13.0565 6.80375 13.6122 7.35943 13.9827 8.03496C14.3693 8.69501 14.5793 9.44349 14.5927 10.2083C14.5846 10.9859 14.3744 11.7481 13.9827 12.42C13.6121 13.0952 13.0565 13.6506 12.381 14.0208C11.7112 14.3959 10.9563 14.5929 10.1885 14.5929C9.42078 14.5929 8.66588 14.3959 7.99602 14.0208C7.32046 13.6504 6.76477 13.0947 6.39435 12.4191C6.01933 11.7492 5.8224 10.9943 5.8224 10.2266C5.8224 9.45891 6.01933 8.70402 6.39435 8.03413C6.7658 7.35842 7.32268 6.80298 7.99935 6.43329C8.67019 6.0421 9.43116 5.8319 10.2077 5.82329ZM10.2077 13.0683C10.9659 13.0672 11.6927 12.7655 12.2288 12.2294C12.7649 11.6933 13.0666 10.9665 13.0677 10.2083C13.0666 9.45011 12.7649 8.7233 12.2288 8.18718C11.6927 7.65107 10.9659 7.34939 10.2077 7.34829C9.4495 7.34939 8.72269 7.65107 8.18657 8.18718C7.65046 8.7233 7.34878 9.45011 7.34768 10.2083C7.33556 10.5855 7.40415 10.9609 7.54887 11.3094C7.6936 11.6579 7.91111 11.9715 8.18685 12.2291C8.44449 12.5049 8.75806 12.7224 9.10658 12.8671C9.45509 13.0118 9.83051 13.0804 10.2077 13.0683ZM15.8127 5.63246C15.8092 5.36066 15.6997 5.10098 15.5074 4.90885C15.3151 4.71672 15.0553 4.60737 14.7835 4.60413C14.6483 4.60205 14.5141 4.62808 14.3894 4.68059C14.2647 4.73309 14.1524 4.81091 14.0593 4.90913C13.9599 5.00119 13.8813 5.11341 13.8287 5.23829C13.7761 5.36317 13.7508 5.49784 13.7543 5.63329C13.744 5.76899 13.7661 5.9052 13.819 6.03058C13.872 6.15597 13.9541 6.26689 14.0585 6.35413C14.146 6.45916 14.2575 6.54168 14.3835 6.59475C14.5095 6.64781 14.6464 6.66989 14.7827 6.65913C14.9131 6.66601 15.0433 6.64197 15.1626 6.58896C15.2819 6.53595 15.387 6.45549 15.4693 6.35413C15.6642 6.16079 15.7856 5.90561 15.8127 5.63246ZM18.711 6.66163C18.711 7.38579 18.7493 8.56829 18.7493 10.2083C18.7493 11.8858 18.711 13.0683 18.6735 13.7916C18.6434 14.424 18.5411 15.0508 18.3685 15.66C18.1417 16.2915 17.777 16.8645 17.301 17.3375C16.8336 17.7931 16.2746 18.1439 15.661 18.3666C15.0451 18.5714 14.403 18.687 13.7543 18.71C13.0302 18.7483 11.8477 18.7483 10.2085 18.7483C8.53102 18.7483 7.34852 18.7483 6.62518 18.71C5.98474 18.6942 5.35216 18.565 4.75685 18.3283C4.12338 18.1436 3.54653 17.8026 3.07935 17.3366C2.61435 16.8623 2.26178 16.2896 2.04768 15.6608C1.84277 15.0581 1.7271 14.4286 1.70435 13.7925C1.66602 13.0683 1.66602 11.8858 1.66602 10.2083C1.66602 8.56829 1.66602 7.38663 1.70435 6.66163C1.72736 6.01296 1.84297 5.37091 2.04768 4.75496C2.27054 4.14173 2.62137 3.58296 3.07685 3.11579C3.5498 2.63979 4.12284 2.27513 4.75435 2.04829C5.36374 1.87571 5.99087 1.77338 6.62352 1.74329C7.34768 1.70496 8.52935 1.66663 10.2077 1.66663C11.8477 1.66663 13.0293 1.70496 13.7535 1.74329C14.3984 1.77368 15.038 1.87598 15.6602 2.04829C16.2752 2.28607 16.8337 2.64974 17.3 3.11599C17.7662 3.58224 18.1299 4.14078 18.3677 4.75579C18.5357 5.38024 18.6506 6.01779 18.711 6.66163ZM16.8777 15.245C17.0578 14.5725 17.1601 13.8816 17.1827 13.1858C17.1827 12.6516 17.221 11.8525 17.221 10.8216V9.59829C17.221 8.56913 17.1827 7.76496 17.1827 7.23413C17.1601 6.53833 17.0578 5.84742 16.8777 5.17496C16.7327 4.8035 16.5125 4.46605 16.2308 4.18382C15.9492 3.90158 15.6122 3.68067 15.241 3.53496C14.5686 3.35488 13.8776 3.25255 13.1818 3.22996C12.6102 3.22996 11.8094 3.19163 10.8177 3.19163H9.59768C8.56852 3.19163 7.76435 3.22996 7.23352 3.22996C6.53772 3.25256 5.84682 3.35489 5.17435 3.53496C4.7992 3.67442 4.45852 3.89311 4.17551 4.17612C3.8925 4.45913 3.67381 4.79981 3.53435 5.17496C3.33522 5.84334 3.23252 6.53672 3.22935 7.23413C3.19102 7.80579 3.19102 8.60413 3.19102 9.59829V10.8183C3.19102 11.8475 3.19102 12.6516 3.22935 13.1825C3.2325 13.8799 3.33521 14.5732 3.53435 15.2416C3.67391 15.6166 3.89264 15.9571 4.17565 16.24C4.45865 16.5229 4.79928 16.7414 5.17435 16.8808C5.84264 17.0805 6.53603 17.1838 7.23352 17.1875C7.76768 17.2258 8.56685 17.2258 9.59768 17.2258H10.8177C11.8468 17.2258 12.651 17.2258 13.1818 17.1875C13.8793 17.1843 14.5726 17.0816 15.241 16.8825C15.6127 16.737 15.9503 16.5161 16.2324 16.2337C16.5145 15.9513 16.7351 15.6135 16.8802 15.2416L16.8777 15.245Z"
                            fill="white"
                          ></path>
                        </g>
                      </svg>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-4">
              <div className="footer-link-block">
                <strong className="footer-link-heading">
                  Quick links
                </strong>
                <ul id="menu-footer-menu" className="footer-links">
                  <li className="current-menu-item">
                    <a href="https://payrofinance.com/category/customer-stories/">
                      Customer reviews
                    </a>
                  </li>
                  <li className="">
                    <a href="https://payrofinance.com/how-it-works/">
                      How it works
                    </a>
                  </li>
                  <li className="">
                    <a href="https://payrofinance.com/payroll-partners/">
                      Partners
                    </a>
                  </li>
                  <li className="">
                    <a href="https://payrofinance.com/contact-us/">
                      Contact Us
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-md-4">
              <div className="footer-enroll">
                <h3>
                  Qualify&nbsp;for payroll funding <br />
                  in minutes
                </h3>
                <a
                  href="https://portal.payrofinance.com/sign-up"
                  className="enroll-Btn"
                >
                  Enroll now free{' '}
                  <svg
                    width="18"
                    height="14"
                    viewBox="0 0 18 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 7H17M17 7L11 1M17 7L11 13"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </a>
                <div className="footer-logo">
                  <ul>
                    <li>
                      <img src="/ippa-logo.png" alt="" />
                    </li>
                    <li>
                      <img src="/APA-logo.png" alt="" />
                    </li>
                    <li>
                      <img src="/AICPA-logo.png" alt="" />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-copyright-block">
          <div className="container">
            <div className="copyright-text">
              <div className="copy-n-menu">
                <div className="copyText">
                  <small>
                    2023. Payro Finance All Rights Reserved
                  </small>
                </div>
                <div className="policy-menu">
                  <a href="https://portal.payrofinance.com/privacy-policy">
                    Privacy Policy
                  </a>
                  <a href="https://portal.payrofinance.com/terms-and-conditions">
                    Terms &amp; Conditions
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* <div id='main'>
        <div className="container-fluid">
          <div className='row'>
            <div id="w-50">
              <img className="actual-logo" src="/color-logo-new-sw.svg" alt="image"/>
            <div  className="head">
            <span className="headin">Proud member of</span>
            <div className='proudBox'>
            <a href="javascript:void(0);" className="order-2 order-sm-1">
              <img src="https://payrofinance.com/wp-content/uploads/2022/02/proud-member-img1.svg" className="attachment-full size-full" alt="" decoding="async" loading="lazy"/>
              </a>
              <a href="javascript:void(0);" className="leftmr">
              <img src="https://payrofinance.com/wp-content/uploads/2022/02/proud-member-img2.svg" className="attachment-full size-full" alt="" decoding="async" loading="lazy"/>
              </a>
            </div>
            </div>
            </div>


            <div id="w-25">
              <h2>Resourses</h2>
              <ul className='foot-items'>
                <li className='foot-item'> <a href="https://payrofinance.com/how-it-works/">How It Works</a></li>
                <li className='foot-item'> <a href="https://payrofinance.com/payroll-partners/">Payroll Partners</a></li>
                <li className='foot-item'> <a href="https://payrofinance.com/about-us/">About us</a></li>
                <li className='foot-item'> <a href="https://payrofinance.com/resources/">Insights</a></li>
                <li className='foot-item'> <a href="https://payrofinance.com/contact-us/">Contact Us</a></li>
                <li className='foot-item'> <a href="https://media.payrofinance.com/policies/PrivacyPolicy.pdf">Privacy Policy</a></li>
                <li className='foot-item'> <a href="https://portal.payrofinance.com/terms-and-conditions">Terms and Conditions</a></li>
              </ul>
            </div>


            <div id="w-25">
              <h2 className='spce py-3'>Get in Touch</h2>
              <p className='normal-txt'>1640 Boro Place, 4th Floor</p>
              <p className='normal-txt'>MClean, VA 22102</p>
              <p className='normal-txt'>1-833-271-4499</p>
              <p className='normal-txt'>hello@payrofinance.com</p>
              <ul className='social-icons'>
                <li className='s-icon'><img className="siz" src="/twitter.png" alt="image" /></li>
                <li className='s-icon'><img className="siz" src="/twitter1.png" alt="image" /></li>
                <li className='s-icon'><img className="siz" src="/twitter2.png" alt="image" /></li>
              </ul>
            </div>
            <hr className='foot'/>
            <p className='marg'>2023. payro Finance All Rights Reserved</p>
          </div>
        </div>
        </div> */}

      {/* <div
        className={
          'footer-container' + (props.page ? ' ' + props.page : '')
        } */}

      {/* <img
          className="actual-logo"
          src="/white-logo-new.svg"
          alt="image"
        /> */}

      {/* <div id="report-an-issue">
          <p>
            To report a security issue with our web application or with
            process, please email security@payrofinance.com.
          </p>
          <p>
            To inform us of a technical issue or general questions,
            please use the chat feature or call us at 1-833-271-4499
          </p>
        </div> */}
      {/* <div id="legal-policy-links">
          <p id="legal-policies-title">Legal Policies</p>
          <a
            target="_blank"
            href="https://media.payrofinance.com/policies/PrivacyPolicy.pdf"
            rel="noreferrer"
          >
            Privacy Policy
          </a>
        </div>
        <div id="footer-bottom"> */}
      {/* <div className="footer-text">
            <p className="actual-text">
              Loan approval is not guaranteed. Approvals are based
              upon Payro’s proprietary scoring and underwriting
              system's review of your credit, financial condition,
              other factors, and supporting documents or information
              you provide.
            </p>
            <p className="actual-text">
              The information provided through payro™ does not
              constitute legal, tax, financial or accounting advice,
              and should not be considered a substitute for obtaining
              competent personalized advice from a licensed
              professional. You should seek professional advice before
              making any decision that could affect the financial
              health of your business. {' '}
            </p>
            <p className="actual-text">
              To help the government fight the funding of terrorism
              and money laundering activities, Federal law requires
              all financial institutions to obtain, verify, and record
              information that identifies each person and business
              that seeks a business loan. What this means for you:
              When you apply for a loan, we will ask for your business
              name, address, and Tax Identification Number. We will
              also ask for your name, address, date of birth, and
              other information that will allow us to identify you.
            </p>
          </div> */}

      {/* <div className="bold-container">
            <p className="bold-text">
              Pay your staff on time */}
      {/* <img
                className="footer-icon-tm"
                src={tmIcon}
                alt="image"
                width={20}
                height={20}
              /> */}
      {/* </p>
          </div> */}
      {/* <div className="icons-container">
            <img
              className="footer-icon-one"
              src={iconThree}
              alt="image"
              width={86.04}
              height={24.58}
            />
          </div> */}
      {/* </div> */}
      {/* </div> */}
    </>
  );
};
